import { render, staticRenderFns } from "./PointTiers.vue?vue&type=template&id=8a160c2a&scoped=true"
import script from "./PointTiers.vue?vue&type=script&lang=js"
export * from "./PointTiers.vue?vue&type=script&lang=js"
import style0 from "./PointTiers.vue?vue&type=style&index=0&id=8a160c2a&prod&lang=css"
import style1 from "./PointTiers.vue?vue&type=style&index=1&id=8a160c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a160c2a",
  null
  
)

export default component.exports